<template>
    <div class="page-title">
        <div class="title">
            <h3>Bookings Profit Report</h3>
        </div>
        <div class="filters">
            <el-form
                label-position="top"
            >
                <el-row>
                    <el-col :span="2" >
                        <el-form-item label="Types">
                            <el-select v-model="form.type"  placeholder="Select" size="small" clearable>
                                <el-option
                                    v-for="item in types"
                                    :key="item"
                                    :label="item"
                                    :value="item"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item class="ml-2" label="Month" size="small" v-if="form.type=='Month'">
                            <el-date-picker
                                v-model="form.month"
                                type="month"
                                placeholder="Pick a month"
                                format="MMM/YYYY"
                                value-format="YYYY-MM"


                            />
                        </el-form-item>
                        <el-form-item class="ml-2" label="Month" size="small" v-else-if="form.type=='Months'">
                            <el-date-picker
                                v-model="form.months"
                                type="monthrange"
                                range-separator="To"
                                start-placeholder="Start month"
                                end-placeholder="End month"
                                format="MMM/YYYY"
                                value-format="YYYY-MM"


                            />
                        </el-form-item>
                        <el-form-item class="ml-2" label="Month" size="small" v-else-if="form.type=='Dates'">
                            <el-date-picker
                                v-model="form.dates"
                                type="daterange"
                                range-separator="To"
                                start-placeholder="Start Date"
                                end-placeholder="End Date"
                                format="DD/MMM/YYYY"
                                value-format="YYYY-MM-DD"


                            />
                        </el-form-item>
                    </el-col>

                    <el-col :span="3">
                        <el-form-item class="ml-2" label=" .">
                            <el-button @click="getlist()"  type="primary" size="small"  round >Apply Filters</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>



            </el-form>



        </div>
    </div>

    <div v-if="!loading">
        <div id="chart">
            <el-row>
                <el-col :span="6">
                    <vue-apex-charts type="donut" height="300" :options="totalleadsstatusCO" :series="reports.leadsstatus.total"></vue-apex-charts>

                </el-col>
                <el-col :span="6">
                    <vue-apex-charts type="donut" height="300" :options="totalleadssourceCO" :series="reports.leadssource.total"></vue-apex-charts>

                </el-col>
                <el-col :span="6">
                    <vue-apex-charts type="donut" height="300" :options="totalleadsdestCO" :series="reports.leadsdest.total"></vue-apex-charts>

                </el-col>

            </el-row>
            <el-row>
                <el-col :span="24">

                    <vue-apex-charts type="line" height="350" :options="leadsstatusCO" :series="reports.leadsstatus.report"></vue-apex-charts>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">

                    <vue-apex-charts type="line" height="350" :options="leadssourceCO" :series="reports.leadssource.report"></vue-apex-charts>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">

                    <vue-apex-charts type="line" height="350" :options="leadsdestCO" :series="reports.leadsdest.report"></vue-apex-charts>
                </el-col>
            </el-row>
        </div>
    </div>
    <div v-else>
        <el-card class="box-card mt-2 booking-list-box" v-for="i in 7" :key="i">
            <el-skeleton :rows="1" animated />
        </el-card>

    </div>

</template>
<style>

</style>
<script>
import  { ElTable,ElTableColumn,ElSpace,ElPagination,ElSelect, ElOption,ElDatePicker,ElFormItem,ElForm,ElCol,ElRow,ElButton,ElCard,ElTag,ElAvatar,ElDivider,ElSkeleton  } from 'element-plus'
import 'element-plus/dist/index.css'
import moment from 'moment'
import VueApexCharts from "vue3-apexcharts";
export default {
    name: "LeadsReportList",
    components: { VueApexCharts,ElTable,ElTableColumn,ElSpace,ElPagination,ElSelect,ElOption,ElDatePicker,ElFormItem,ElForm,ElCol,ElRow,ElButton,ElCard,ElTag,ElAvatar,ElDivider,ElSkeleton },
    data() {
        return {
            loading: true,
            form:{
                dates:[moment().startOf('month').format('YYYY-MM-DD'),moment().format('YYYY-MM-DD')],
                month:moment().startOf('month').format('YYYY-MM'),
                months:[moment().startOf('year').format('YYYY-MM'),moment().startOf('month').format('YYYY-MM')],
                type:'Month',
            },
            data:{
                user:null,
                services:[]
            },
            types:[
                'Month',
                'Months',
                'Dates',
            ],
            leadsstatusCO: {
                legend: {
                    onItemClick: {
                        toggleDataSeries: true
                    },
                },
                chart: {
                    height: 350,
                    type: 'line',
                    zoom: {
                        enabled: false
                    }
                },
                dataLabels: {
                    enabled: true
                },
                stroke: {
                    curve: 'straight',
                    width:2
                },
                title: {
                    text: 'Booking Report',
                    align: 'left'
                },
                grid: {
                    row: {
                        colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                        opacity: 0.5
                    },
                },
                xaxis: {
                    categories: [],
                },
                yaxis: {
                    title: {
                        text: 'Leads'
                    },
                    min: 0
                },
                markers: {
                    size: 1
                },

            },
            totalleadsstatusCO:{
                title: {
                    text: 'Total Booking Report',
                    align: 'left'
                },
                legend: {
                    onItemClick: {
                        toggleDataSeries: true
                    },
                },
                chart: {
                    width: 380,
                    type: 'pie',
                },
                labels: [''],
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            },
            leadssourceCO: {
                legend: {
                    onItemClick: {
                        toggleDataSeries: true
                    },
                },
                chart: {
                    height: 350,
                    type: 'line',
                    zoom: {
                        enabled: false
                    }
                },
                dataLabels: {
                    enabled: true
                },
                stroke: {
                    curve: 'straight',
                    width:2
                },
                title: {
                    text: 'Booking Source Report',
                    align: 'left'
                },
                grid: {
                    row: {
                        colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                        opacity: 0.5
                    },
                },
                xaxis: {
                    categories: [],
                },
                yaxis: {
                    title: {
                        text: 'Leads'
                    },
                    min: 0
                },
                markers: {
                    size: 1
                },

            },
            totalleadssourceCO:{
                legend: {
                    onItemClick: {
                        toggleDataSeries: true
                    },
                },
                chart: {
                    width: 380,
                    type: 'donut',
                },
                title: {
                    text: 'Total Booking Source Report',
                    align: 'left'
                },
                plotOptions:{
                    pie:{
                        donut:{
                            labels:{
                                show: true,
                                total: {
                                    show: true,
                                    showAlways: true,
                                    label: 'Total',
                                },
                                name: {
                                    show: false
                                },
                                value: {
                                    show: false
                                }
                            },
                        }
                    },
                },

                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            },
            leadsdestCO: {
                legend: {
                    onItemClick: {
                        toggleDataSeries: true
                    },
                },
                chart: {
                    height: 350,
                    type: 'line',
                    zoom: {
                        enabled: false
                    }
                },
                dataLabels: {
                    enabled: true
                },
                stroke: {
                    curve: 'straight',
                    width:2
                },
                title: {
                    text: 'Booking Destination Report',
                    align: 'left'
                },
                grid: {
                    row: {
                        colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                        opacity: 0.5
                    },
                },
                xaxis: {
                    categories: [],
                },
                yaxis: {
                    title: {
                        text: 'Leads'
                    },
                    min: 0
                },
                markers: {
                    size: 1
                },

            },
            totalleadsdestCO:{
                legend: {
                    onItemClick: {
                        toggleDataSeries: true
                    },
                },
                chart: {
                    width: 380,
                    type: 'donut',
                },
                title: {
                    text: 'Total Booking Destination Report',
                    align: 'left'
                },
                plotOptions:{
                    pie:{
                        donut:{
                            labels:{
                                show: true,
                                total: {
                                    show: true,
                                    showAlways: true,
                                    label: 'Total',
                                },
                                name: {
                                    show: false
                                },
                                value: {
                                    show: false
                                }
                            },
                        }
                    },
                },

                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            },
            reports:[]

        }
    },
    mounted() {
        this.getlist();
    },
    methods: {
        getlist() {
            this.loading=true;
            let currentObj = this;
            axios.post('/report/bookingsprofit',this.form).then(function (response) {

                currentObj.reports=response.data.reports;
                currentObj.data=response.data.data;
                currentObj.leadsstatusCO.xaxis=response.data.reports.leadsstatus.xaxis;
                currentObj.totalleadsstatusCO.labels=response.data.reports.leadsstatus.totalxaxis;
                currentObj.leadssourceCO.xaxis=response.data.reports.leadssource.xaxis;
                currentObj.totalleadssourceCO.labels=response.data.reports.leadssource.totalxaxis;
                currentObj.leadsdestCO.xaxis=response.data.reports.leadsdest.xaxis;
                currentObj.totalleadsdestCO.labels=response.data.reports.leadsdest.totalxaxis;



                currentObj.loading=false;

            })
                .catch(function (error) {
                    currentObj.loading=false;
                });
        },
        openbooking(link){
            window.open(link, "_blank", "width="+screen.availWidth+",height="+screen.availHeight)

        }
    }
}
</script>

<style scoped>

</style>


